const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const BlackFriday = () => import(/* webpackChunkName:"chunk-blackfriday" */ '../views/P5_Activitys/BlackFriday')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

const ChristmasMainMale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActMaleMain.vue')
const ChristmasRankMale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActMaleRank.vue')
const ChristmasRulesMale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActMaleRules.vue')
const ChristmasMainFemale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActFemaleMain.vue')
const ChristmasRankFemale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActFemaleRank.vue')
const ChristmasRulesFemale = () => import(/* webpackChunkName:"chunk-christmas" */ '../views/P5_Activitys/Christmas/holidayActFemaleRules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const Halloween2025MainMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleMain.vue')
const Halloween2025RankMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleRank.vue')
const Halloween2025RulesMale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActMaleRules.vue')
const Halloween2025MainFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleMain.vue')
const Halloween2025RankFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleRank.vue')
const Halloween2025RulesFemale = () => import(/* webpackChunkName:"chunk-halloween2025" */ '../views/P5_Activitys/Halloween/holidayActFemaleRules.vue')

const HolidayMainMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleMain.vue')
const HolidayRankMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleRank.vue')
const HolidayRulesMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleRules.vue')
const HolidayMainFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleMain.vue')
const HolidayRankFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleRank.vue')
const HolidayRulesFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleRules.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const NewYearsDayMainMale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActMaleMain.vue')
const NewYearsDayRankMale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActMaleRank.vue')
const NewYearsDayRulesMale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActMaleRules.vue')
const NewYearsDayMainFemale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActFemaleMain.vue')
const NewYearsDayRankFemale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActFemaleRank.vue')
const NewYearsDayRulesFemale = () => import(/* webpackChunkName:"chunk-NewYearsDay" */ '../views/P5_Activitys/NewYearsDay/holidayActFemaleRules.vue')


const RechargeNinePointNinetyNine = () => import(/* webpackChunkName:"chunk-rechargeNinePointNinetyNine" */ '../views/P5_Activitys/NinePointNinetyNine/index.vue')

const NineteenNinetyNineActivity = () => import(/* webpackChunkName:"chunk-nineteenninetynine" */ '../views/P5_Activitys/NineteenNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SayHi = () => import(/* webpackChunkName:"chunk-sayhi" */ '../views/P5_Activitys/SayHi/index.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter',
    name: 'act-enter',
    component: EnterBar
  },
  // 啤酒收集节
  {
    path: '/beer-collect',
    name: 'beer-collect',
    component: BeerAct
  },
  // 黑色星期五
  {
    path: '/black-friday',
    name: 'black-friday',
    component: BlackFriday
  },
  // 男用户通话激励
  {
    path: '/call-motivation',
    name: 'call-motivation',
    component: CallMotivation
  },
  {
    path: '/call-motivation-rules',
    name: 'call-motivation',
    component: CallMotivationRules
  },
  // 圣诞节-2025
  {
    path: '/christmas-main-male',
    name: 'christmas-main-male',
    component: ChristmasMainMale
  },
  {
    path: '/christmas-rank-male',
    name: 'christmas-rank-male',
    component: ChristmasRankMale
  },
  {
    path: '/christmas-rules-male',
    name: 'christmas-rules-male',
    component: ChristmasRulesMale
  },
  {
    path: '/christmas-main-female',
    name: 'christmas-main-female',
    component: ChristmasMainFemale
  },
  {
    path: '/christmas-rank-female',
    name: 'christmas-rank-female',
    component: ChristmasRankFemale
  },
  {
    path: '/christmas-rules-female',
    name: 'christmas-rules-female',
    component: ChristmasRulesFemale
  },
  // 自定义图片页面
  {
    path: '/dy-page/:customPageId',
    name: 'dy-page',
    component: DyPage
  },
  // 万圣节-2025
  {
    path: '/halloween2025-main-male',
    name: 'holiday-main-male',
    component: Halloween2025MainMale
  },
  {
    path: '/halloween2025-rank-male',
    name: 'halloween2025-rank-male',
    component: Halloween2025RankMale
  },
  {
    path: '/halloween2025-rules-male',
    name: 'halloween2025-rules-male',
    component: Halloween2025RulesMale
  },
  {
    path: '/halloween2025-main-female',
    name: 'halloween2025-main-female',
    component: Halloween2025MainFemale
  },
  {
    path: '/halloween2025-rank-female',
    name: 'halloween2025-rank-female',
    component: Halloween2025RankFemale
  },
  {
    path: '/halloween2025-rules-female',
    name: 'halloween2025-rules-female',
    component: Halloween2025RulesFemale
  },
  // 法定节假日
  {
    path: '/holiday-main-male-br',
    name: 'holiday-main-male-br',
    component: HolidayMainMaleBr
  },
  {
    path: '/holiday-rank-male-br',
    name: 'holiday-rank-male-br',
    component: HolidayRankMaleBr
  },
  {
    path: '/holiday-rules-male-br',
    name: 'holiday-rules-male-br',
    component: HolidayRulesMaleBr
  },
  {
    path: '/holiday-main-female-br',
    name: 'holiday-main-female-br',
    component: HolidayMainFemaleBr
  },
  {
    path: '/holiday-rank-female-br',
    name: 'holiday-rank-female-br',
    component: HolidayRankFemaleBr
  },
  {
    path: '/holiday-rules-female-br',
    name: 'holiday-rules-female-br',
    component: HolidayRulesFemaleBr
  },
  {
    path: '/incentive-act',
    name: 'incentive-act',
    component: Incentive
  },
  {
    path: '/incentive-fornew',
    name: 'incentive-fornew',
    component: IncentiveForNew
  },
  // 升级奖励
  {
    path: '/liveness',
    name: 'liveness',
    component: Liveness
  },
  {
    path: '/liveness-rules',
    name: 'liveness-rules',
    component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay',
    name: 'matching-to-pay',
    component: MatchingToPay
  },
  // 元旦节-2025
  {
    path: '/newyearsday-main-male',
    name: 'newyearsday-main-male',
    component: NewYearsDayMainMale
  },
  {
    path: '/newyearsday-rank-male',
    name: 'newyearsday-rank-male',
    component: NewYearsDayRankMale
  },
  {
    path: '/newyearsday-rules-male',
    name: 'newyearsday-rules-male',
    component: NewYearsDayRulesMale
  },
  {
    path: '/newyearsday-main-female',
    name: 'newyearsday-main-female',
    component: NewYearsDayMainFemale
  },
  {
    path: '/newyearsday-rank-female',
    name: 'newyearsday-rank-female',
    component: NewYearsDayRankFemale
  },
  {
    path: '/newyearsday-rules-female',
    name: 'newyearsday-rules-female',
    component: NewYearsDayRulesFemale
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety',
    name: 'recharge-ninepointninety',
    component: RechargeNinePointNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine',
    name: 'nineteen-ninety_nine-activity',
    component: NineteenNinetyNineActivity
  },
  // vava 主播限时付费电话补贴
  {
    path: '/private-call-income',
    name: 'private-call-income',
    component: PrivateCallIncome
  },
  // 充值-首充之后再充
  {
    path: '/recharge-afterfirst',
    name: 'recharge-afterfirst',
    component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first',
    name: 'recharge-first',
    component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small',
    name: 'recharge-low-small',
    component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r',
    name: 'recharge-mid-r',
    component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r',
    name: 'recharge-top-r',
    component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase',
    name: 'repurchase',
    component: Repurchase
  },
  // SayHi
  {
    path: '/say-hi',
    name: 'say-hi',
    component: SayHi
  }
]
export default routes
